import { useState } from "react";
import { Navigate, useNavigate, useParams } from "react-router";
import t from "../locales";
import CATEGORIES from "../data/categories";
import Dialog from "../components/dialog";

export default function Fragments() {
  const { category } = useParams();
  const navigate = useNavigate();
  const [selectedFragment, setSelectedFragment] = useState(null);

  if (CATEGORIES[category] === undefined) {
    return <Navigate to="/" />;
  }

  const fragments = CATEGORIES[category].fragments;

  function handleSelectFragment(fragmentKey) {
    setSelectedFragment(fragmentKey);
  }

  function handleCloseDialog() {
    setSelectedFragment(null);
  }

  function handleDialogSubmit(groupCode) {
    const group = groupCode?.trim();

    if (!group || !selectedFragment) return;

    setSelectedFragment(null);
    navigate(
      `/${category}/${selectedFragment}?group=${encodeURIComponent(group)}`,
    );
  }

  return (
    <>
      <title>{t("survey.title")}</title>
      <div className="sheet">
        <h1 className="sheet__title">{t("survey.heading")}</h1>
        <div className="fragment-container">
          {Object.entries(fragments).map(([fragmentKey, fragment]) => (
            <button
              className="fragment"
              key={fragmentKey}
              onClick={() => handleSelectFragment(fragmentKey)}
            >
              <div className="fragment__content">
                <img className="fragment__image" src={fragment.image} />
                <h2 className="fragment__title">{fragment.title}</h2>
              </div>
            </button>
          ))}
        </div>
      </div>
      <Dialog
        isOpen={selectedFragment !== null}
        onClose={handleCloseDialog}
        onSubmit={handleDialogSubmit}
        title={t("survey.dialog.title")}
        description={t("survey.dialog.description")}
        inputPlaceholder={t("survey.dialog.input.placeholder")}
        submitLabel={t("survey.dialog.submit")}
      />
    </>
  );
}
